import { z } from 'zod'

const responseData = z.object({
  status: z.number()
})

const errorWithResponse = z.object({
  response: responseData
})

type ErrorWithResponse = z.infer<typeof errorWithResponse>

export const isErrorWithResponse = (obj: unknown): obj is ErrorWithResponse =>
  errorWithResponse.safeParse(obj).success
